export const newsQuery = `
    query news($category: [QueryArgument], $limit: Int, $offset: Int, $search: String) {
        entryCount(
            section: "ds_News",
            search: $search
            relatedToCategories: {
                id: $category
            }
        )
        ds_NewsEntries(
            limit: $limit
            offset: $offset
            orderBy: "postDate DESC"
            search: $search
            relatedToCategories: {
                id: $category
            }
        ) {
            ... on ds_News_Entry {
                id
                title
                uri
                image {
                    url @transform(width: 800, height: 600)
                    focalPoint
                    alt
                }
                postDate
                category {
                    title
                }
                articleExcerpt
            }
        }
    }
`

export const newsLayoutQuery = `
    query news($offset: Int) {
        entryCount(
            section: "ds_News",
        )
        ds_NewsEntries(
            offset: $offset
            orderBy: "postDate DESC"
        ) {
            ... on ds_News_Entry {
                id
                title
                uri
                image {
                    url @transform(width: 800, height: 600)
                    focalPoint
                    alt
                }
                postDate
                articleExcerpt
            }
        }
    }
`

export const newsLayoutQueryWithId = `
    query news($id: [QueryArgument]) {
        entryCount(
            section: "ds_News",
        )
        ds_NewsEntries(
            orderBy: "postDate DESC"
            id: $id
        ) {
            ... on ds_News_Entry {
                id
                title
                uri
                image {
                    url @transform(width: 800, height: 600)
                    focalPoint
                    alt
                }
                postDate
                articleExcerpt
            }
        }
    }
`
